
import './SaveTestApp_new.scss';
import * as S from '../scss/theme';
import React, { useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import SaveTest_tv from './SaveTest_tv_new';
import SaveTest_table_new from './SaveTest_table_new';

const SaveTestApp_new = ({setIsFastSearch}) => {

// const isModal_mun = useSelector(state => state.reduxStoreMun.isModal_mun);
const isModal_mun = false; // 임시로 false로 설정, 실제로는 Redux 상태에서 가져와야 함
const [selectedMunCode, setSelectedMunCode] = useState(null);
const [selectedNodeId, setSelectedNodeId] = useState(null);
const [testCnt, setTestCnt] = useState(0);
const [nthNode, setNthNode] = useState(null);
  
//========================================================
    return (//modal로 하는 것 포기 (로그기록으로 해야 할 듯)
    <S.Section>
      <div className='SaveTestApp_new'>
        
        <section className='section1'>
          <SaveTest_tv 
              setSelectedNodeId={setSelectedNodeId} 
              testCnt={testCnt}
          
              setNthNode={setNthNode}
            />
        </section>

        <section className='section2'>
            <SaveTest_table_new 
              selectedNodeId={selectedNodeId} 
              setTestCnt={setTestCnt} 
              nthNode={nthNode} 
              setIsFastSearch={setIsFastSearch} 
            />
        </section>

      </div>
    </S.Section>
      );
    };


export default SaveTestApp_new;